import React from 'react';
import { Link } from 'react-router-dom';

const RelatedSolutions = ({ solutions, currentSolutionId }) => {
  // Filter out the current solution and limit to 3 related solutions
  const relatedSolutions = solutions
    .filter(solution => solution.id !== currentSolutionId)
    .slice(0, 3);

  if (!relatedSolutions || relatedSolutions.length === 0) {
    return null;
  }

  // Helper function to render rich text description
  const renderDescription = (description) => {
    if (!description) return '';
    
    if (typeof description === 'string') {
      return description;
    }
    
    if (Array.isArray(description)) {
      return description.map(block => {
        if (block.type === 'paragraph' && block.children) {
          return block.children.map(child => child.text || '').join('');
        }
        return '';
      }).join(' ');
    }
    
    return '';
  };

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-catalina-blue mb-4">
            Related Solutions
          </h2>
          <p className="text-gray-600">
            Explore other solutions that might interest you
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {relatedSolutions.map((solution) => {
            const title = solution.Title || solution.title;
            const description = renderDescription(solution.Description || solution.description);
            const slug = solution.slug;

            return (
              <div
                key={solution.id}
                className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition duration-300"
              >
                <div className="p-6">
                  <div className="bg-catalina-blue rounded-xl w-14 h-14 flex items-center justify-center mb-4">
                    <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold text-catalina-blue mb-3">
                    {title}
                  </h3>
                  <p className="text-gray-600 mb-4 line-clamp-3">
                    {description}
                  </p>
                  <Link
                    to={`/solution/${slug}`}
                    className="inline-flex items-center text-catalina-blue font-semibold hover:text-tango transition duration-300"
                  >
                    Learn More
                    <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </Link>
                </div>
              </div>
            );
          })}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/solutions-we-provide/all"
            className="inline-block bg-catalina-blue text-white px-8 py-3 rounded-lg font-semibold hover:bg-san-marino transition duration-300"
          >
            View All Solutions
          </Link>
        </div>
      </div>
    </section>
  );
};

export default RelatedSolutions;